import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Popup.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { RegisterData, RegistrierenLoginPopupProps } from "modules/register-login";
import { FaArrowAltCircleRight } from "react-icons/fa";
import ErrorFailed from "components/errorFailed/errorFailed";
import { checkEmail } from "services/userLogin/check-email";
import { registerUser } from "services/userLogin/user-register";



export default function RegistrierenPopup({ isOpen, onClose, togglePopup }: RegistrierenLoginPopupProps) {
    const navigate = useNavigate();
    const [animationState, setAnimationState] = useState("popupExit");
    const [error, setError] = useState<string | null>(null);
    const [formRegisterData, setFormRegisterData] = useState<RegisterData>({
        email: '',
        password: '',
        repassword: '',
        termsChecked: true,
    });

    useEffect(() => {
        if (isOpen) {
            setAnimationState("popupEnter");
        } else {
            setAnimationState("popupExit");
            resetForm();
        }
    }, [isOpen]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, type, checked, value } = e.target;
        setFormRegisterData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const validateForm = async (): Promise<boolean> => {
        if (formRegisterData.password !== formRegisterData.repassword) {
            setError("Die Passwörter stimmen nicht überein.");
            return false;
        }

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*-_+?&])[A-Za-z\d@$!%*-_+?&]{8,}$/;
        if (!passwordRegex.test(formRegisterData.password)) {
            setError(
                "Das Passwort muss mindestens 8 Zeichen lang sein, einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten."
            );
            return false;
        }
        if (!formRegisterData.termsChecked) {
            setError("Bitte bestätigen Sie die Nutzungsbedingungen.");
            return false;
        }


        try {
            const res = await checkEmail(formRegisterData.email);
            if (res.exists) {
                setError("Die E-Mail-Adresse ist bereits registriert.");
                return false;
            }
        } catch (error) {
            setError("Serverfehler. Bitte versuchen Sie es später noch einmal.");
            return false;
        }



        return true;
    };


    const resetForm = () => {
        setFormRegisterData({
            email: '',
            password: '',
            repassword: '',
            termsChecked: true,
        });
        setError(null);
    };
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(null);

        const isValid = await validateForm();
        if (!isValid) return;

        try {
            await registerUser({
                email: formRegisterData.email,
                password: formRegisterData.password,
            });
            onClose();
            navigate('/reservierungsportal/compliatProfile');
        } catch (error) {
            setError("Serverfehler. Bitte versuchen Sie es später noch einmal.");
        }
    };

    if (!isOpen && animationState === "popupExit") return null;

    return (
        <div className={`${styles.popupContainer} ${styles[animationState]}`}>
            <div className={styles.popupContent}>
                <div className={styles.popupheader}>
                    <h2>Registrieren</h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        &times;
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={styles.form}>
                        {error && <ErrorFailed error={error} />}

                        <div className={styles.formGroup}>
                            <label htmlFor="email">E-Mail</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formRegisterData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="password">Passwort</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formRegisterData.password}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="repassword">Passwort wiederholen</label>
                            <input
                                type="password"
                                id="repassword"
                                name="repassword"
                                value={formRegisterData.repassword}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className={styles.checkboxContainer}>
                            <input
                                type="checkbox"
                                id="terms"
                                name="termsChecked"
                                checked={formRegisterData.termsChecked}
                                onChange={handleChange}

                            />
                            <label htmlFor="terms">
                                Hiermit bestätige ich die Datenschutzhinweise und die Datenschutzerklärung gelesen zu haben und gebe(n) mein Einverständnis zur Nutzung meiner Daten.
                            </label>
                        </div>

                        <div className={styles.registerContainer}>
                            <p>Du hast bereits einen Account? </p>
                            <a
                                className={styles.registerLink}
                                onClick={() => { onClose(); togglePopup(); }}
                            >
                                Jetzt Einloggen
                            </a>
                        </div>
                        <div className={styles.buttonContainer}>
                            <button
                                type="submit"
                                className={`${commonStyles.commonButton} ${styles.loginButton}`}
                            >
                                <span>Registrieren</span>
                                <FaArrowAltCircleRight className={commonStyles.commonButtonIcon} />
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
